import * as React from "react";
import * as Loadable from "react-loadable";

// Containers
import Home from "../Containers/Home";
import Assets from "../Containers/Assets";
import Customers from "../Containers/Customers";
import CustomerRequestPortal from "../Containers/CustomerRequestPortal";
import Dashboard from "../Containers/Dashboard";
import Parts from "../Containers/Parts";
import Requests from "../Containers/Requests";
import Reports from "../Containers/Reports";
import Schedule from "../Containers/Schedule";
import SignIn from "../Containers/Login";
import SignUp from "../Containers/SignUp";
import Sites from "../Containers/Sites";
import Users from "../Containers/Users";
import UserInvitation from "../Containers/UserInvitation";
import VerifyEmail from "../Containers/VerifyEmail";
import WorkOrders from "../Containers/WorkOrders";

const AsyncHome = Loadable({
  loader: () => Promise.resolve(Home),
  loading: () => <div>Loading ...</div>
});

const AsyncSignIn = Loadable({
  loader: () => Promise.resolve(SignIn),
  loading: () => <div>Loading ...</div>
});

const AsyncSignUp = Loadable({
  loader: () => Promise.resolve(SignUp),
  loading: () => <div>Loading ...</div>
});

const AsyncDashboard = Loadable({
  loader: () => Promise.resolve(Dashboard),
  loading: () => <div>Loading ...</div>
});

const AsyncSchedule = Loadable({
  loader: () => Promise.resolve(Schedule),
  loading: () => <div>Loading ...</div>
});

const AsyncVerifyEmail = Loadable({
  loader: () => Promise.resolve(VerifyEmail),
  loading: () => <div>Loading ...</div>
});

const AsyncUserInvitation = Loadable({
  loader: () => Promise.resolve(UserInvitation),
  loading: () => <div>Loading ...</div>
});

const AsyncWorkOrders = Loadable({
  loader: () => Promise.resolve(WorkOrders),
  loading: () => <div>Loading ...</div>
});

const AsyncAssets = Loadable({
  loader: () => Promise.resolve(Assets),
  loading: () => <div>Loading ...</div>
});

const AsyncSites = Loadable({
  loader: () => Promise.resolve(Sites),
  loading: () => <div>Loading ...</div>
});

const AsyncParts = Loadable({
  loader: () => Promise.resolve(Parts),
  loading: () => <div>Loading ...</div>
});

const AsyncCustomers = Loadable({
  loader: () => Promise.resolve(Customers),
  loading: () => <div>Loading ...</div>
});

const AsyncUsers = Loadable({
  loader: () => Promise.resolve(Users),
  loading: () => <div>Loading ...</div>
});

const AsyncCustomerRequestPortal = Loadable({
  loader: () => Promise.resolve(CustomerRequestPortal),
  loading: () => <div>Loading ...</div>
});

const AsyncRequests = Loadable({
  loader: () => Promise.resolve(Requests),
  loading: () => <div>Loading ...</div>
});

const AsyncReports = Loadable({
  loader: () => Promise.resolve(Reports),
  loading: () => <div>Loading ...</div>
});

const routes = [
  {
    title: "Home",
    path: "/",
    component: AsyncHome,
    exact: true,
    private: false
  },
  {
    title: "Sign In",
    path: "/sign-in",
    component: AsyncSignIn,
    exact: true,
    private: false
  },
  {
    title: "Sign Up",
    path: "/sign-up",
    component: AsyncSignUp,
    exact: true,
    private: false
  },
  {
    title: "Verify Email",
    path: "/verify-email/:token",
    component: AsyncVerifyEmail,
    exact: true,
    private: false
  },
  {
    title: "User Invitation",
    path: "/user-invitation/:token",
    component: AsyncUserInvitation,
    exact: true,
    private: false
  },
  {
    title: "Customer Request Portal",
    path: "/customer-request-portal/:customerId",
    component: AsyncCustomerRequestPortal,
    exact: true,
    private: false
  },
  {
    title: "Dashboard",
    path: "/dashboard",
    component: AsyncDashboard,
    exact: true,
    private: true
  },
  {
    title: "Work Orders",
    path: "/work-orders",
    component: AsyncWorkOrders,
    exact: true,
    private: true
  },
  {
    title: "Schedule",
    path: "/schedule",
    component: AsyncSchedule,
    exact: true,
    private: true
  },
  {
    title: "Reports",
    path: "/reports",
    component: AsyncReports,
    exact: true,
    private: true
  },
  {
    title: "Users",
    path: "/users",
    component: AsyncUsers,
    exact: true,
    private: true
  },
  {
    title: "Assets",
    path: "/assets",
    component: AsyncAssets,
    exact: true,
    private: true
  },
  {
    title: "Sites",
    path: "/sites",
    component: AsyncSites,
    exact: true,
    private: true
  },
  {
    title: "Parts",
    path: "/parts",
    component: AsyncParts,
    exact: true,
    private: true
  },
  {
    title: "Customers",
    path: "/customers",
    component: AsyncCustomers,
    exact: true,
    private: true
  },
  {
    title: "Requests",
    path: "/requests",
    component: AsyncRequests,
    exact: true,
    private: true
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/Navigation/Routes.tsx